<div class="shell" [class.shell--offline]="offlineState.enabled()">
  <!-- Chrome permanente: os dois são position:fixed, então precisam ficar FORA do nz-sider,
       senão o overflow do sider recorta o painel. -->
  <app-notifications-panel />
  <app-notifications-toaster />
  <!-- O assistente (lançador, painel e cards) sai do chunk inicial: carrega quando o navegador fica ocioso. -->
  @if (!isReader()) {
    @defer (on idle) {
      <app-platform-assistant />
    }
  }
  <!-- DEV-966: barra fixa do Modo Offline (CA 04) e toast da sincronização, no mesmo lugar do chrome. -->
  <app-offline-mode-banner />
  <app-offline-sync-toast />

  <nz-layout class="container">
    <nz-sider
      class="menu-container desktop-only"
      [class.menu-container--panel-open]="notificationsState.panelOpen()"
      [nzWidth]="76"
      [nzTrigger]="null">
      <app-menu data-cy="vertical-menu" />
    </nz-sider>

    <nz-layout class="body-container has-bottom-nav" [class.body-container--flush]="flushBody()">
      @if (showPageHeader()) {
        <header class="action-hero">
          <div class="action-hero__art" aria-hidden="true">
            <svg class="action-hero__doodle action-hero__doodle--check" viewBox="0 0 40 40">
              <path d="M7 21l8 8 18-19" />
            </svg>
            <svg class="action-hero__doodle action-hero__doodle--sparkle" viewBox="0 0 24 24">
              <path d="M12 2c1 5 2 6 7 7-5 1-6 2-7 7-1-5-2-6-7-7 5-1 6-2 7-7Z" />
            </svg>
            <svg class="action-hero__doodle action-hero__doodle--ring" viewBox="0 0 32 32">
              <path d="M16 4a12 12 0 1 0 7 2.2" />
            </svg>
            <svg class="action-hero__doodle action-hero__doodle--dots" viewBox="0 0 44 24">
              <circle cx="6" cy="14" r="2.6" />
              <circle cx="22" cy="6" r="2.6" />
              <circle cx="38" cy="16" r="2.6" />
            </svg>
          </div>
          <h1 class="action-hero__title">{{ pageTitle() }}</h1>
          <p class="action-hero__lead">
            {{ pageDescription() }}
          </p>
        </header>
        <!--        <div class="header-container">-->
        <!--          <i [class]="icon()"></i>-->
        <!--          <div class="text-container">-->
        <!--            <h1>{{ pageTitle() }}</h1>-->
        <!--            <span>{{ pageDescription() }}</span>-->
        <!--          </div>-->
        <!--        </div>-->
      }

      <nz-content>
        <div class="content">
          <router-outlet />
        </div>
      </nz-content>
    </nz-layout>

    <app-bottom-nav class="mobile-only" />
  </nz-layout>
</div>
